'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactHelmet = require('react-helmet');

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NotFoundRedirect = function NotFoundRedirect() {
  return _react2.default.createElement(_reactHelmet2.default, { meta: [{
      'http-equiv': 'refresh',
      content: '0;URL="/404"'
    }] });
};

exports.default = NotFoundRedirect;


//////////////////
// WEBPACK FOOTER
// ./lib/shared/NotFoundRedirect.js
// module id = 606
// module chunks = 0